/** imported components

  * BreadcrumbsItem for ===> dynamic breadcrumb component of react.
  * $ from jquery ===> component from jquery to use jquery for the page.
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  * Helmet ===> for add specific title & CSS for the page.
  * serviceProvider for ===> working with api
  * .scss for ===> styling css file for this page.
  
**/
import React, { useContext, useEffect } from "react";
import "./skills-assessment-page.scss";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { Link} from "react-router-dom";
import { CartContext } from "../../contexts/CartContext";
//SkillsAssessmentPageView component start
export const SkillsAssessmentPageView = (props) => {
  let skillData = [
    {
        "id": "11",
        "certificate_ref_id": "1",
        "course_name": "Introduction to Industry 4.0",
        "course_slug": "introduction-to-industry-40",
        "course_icon": "course-symb.svg",
        "course_snippet": "Our introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
        "course_technology": "",
        "course_description": "An introduction to Industry 4.0 disruption and its effect in modern manufacturing.<br/><br/>Our introductory course intends to make participants become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.",
        "skill_desc": "Industry 4.0 disruption and its effect in modern manufacturing that can initiate an exiting digital transformation journey.",
        "course_image": "Introduction-to-Industry-40-Training.png",
        "course_instructor": "1",
        "course_order": "1",
        "social_url": "/industry-40-training-courses",
        "price": "0",
        "meta_desc": "Industry 4.0 introductory course intends to make you become aware of the philosophy evolution and prepare teams for the digital transformation journey, creating excitement and a pull approach.​",
        "meta_img": "Introduction-to-Industry-40-Training.png\n",
        "is_imd": "1",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "1",
        "certificate_ref_id": "2",
        "course_name": "Factory of the Future Leadership",
        "course_slug": "factory-of-the-future-leadership",
        "course_icon": "fof-leadership.svg",
        "course_snippet": "Participants will learn various aspects that enable effective execution, such as being visionary and inspiring, strategic, and agile while always focusing to an end to end approach to digital transformation.",
        "course_technology": "",
        "course_description": "Leadership behaviours and strategies that inspire, support and offer guidance in order to accelerate and guarantee the digital transformation’s success across the organization.<br/><br/>For effective execution, leaders need to master various aspects such as being visionary and inspiring, strategic, and agile while always focus to an end to end approach to digital transformation.",
        "skill_desc": "Leadership behaviours and strategies that inspire, support and offer guidance in order to accelerate and guarantee the digital transformation’s success across the organization.<br><br> For effective execution, leaders need to master various aspects such as being visionary and inspiring, strategic, and agile while always focus to an end to end approach to digital transformation.",
        "course_image": "Factory-of-the-Future-Leadership-Training.png",
        "course_instructor": "1",
        "course_order": "2",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "For effective execution, leaders need to master various aspects such as being visionary and inspiring, strategic, and agile while always focus to an end-to-end approach to digital transformation.​",
        "meta_img": "Factory-of-the-Future-Leadership-Training.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "2",
        "certificate_ref_id": "3",
        "course_name": "Digital Organization",
        "course_slug": "digital-organization",
        "course_icon": "digital-organization.svg",
        "course_snippet": "Participants will learn about structures and policies that act as enablers to roll out an effective digital strategy and are crucial to successfully embracing the opportunities of Industry 4.0.",
        "course_technology": "",
        "course_description": "Structures and policies that provide the agility to design the interventions required to organizational culture, development of employee’s skills and new talent acquisition.<br/><br/>All the above act as enablers to roll out an effective digital strategy and are crucial to successfully embracing the opportunities of Industry 4.0.",
        "skill_desc": "Structures and policies that provide the agility to design the interventions required to organizational culture, development of employee’s skills and new talent acquisition.\n<br><br>All the above act as enablers to roll out an effective digital strategy and are crucial to successfully embracing the opportunities of Industry 4.0.",
        "course_image": "Digital-Organization-Training.png",
        "course_instructor": "1",
        "course_order": "3",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Learn about structures and policies that act as enablers to roll out an effective digital strategy and are crucial to successfully embracing the opportunities of Industry 4.0.​",
        "meta_img": "Digital-Organization-Training.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "3",
        "certificate_ref_id": "4",
        "course_name": "Data-Driven Maintenance",
        "course_slug": "data-driven-maintenance",
        "course_icon": "data-driven-maintenance.svg",
        "course_snippet": "Participants will learn how Data-Driven Maintenance practices are key to driving operational efficiency and reducing downtime.",
        "course_technology": "Automatic Lubrication Systems, Condition Monitoring, CMMS, Predictive Maintenance, 3D Printing​.",
        "course_description": "The implementation of methods and systems to proactively manage maintenance based on data, such as equipment condition metrics and historical events.<br/><br/>Data-Driven Maintenance practices are key to driving operational efficiency and reducing downtime.",
        "skill_desc": "The implementation of methods and systems to proactively manage maintenance based on data, such as equipment condition metrics and historical events.\n<br><br>Data-Driven Maintenance practices are key to driving operational efficiency and reducing downtime.",
        "course_image": "Data-driven-Maintenance-Training.png",
        "course_instructor": "5",
        "course_order": "4",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Learn how Data-Driven Maintenance practices are key to driving operational efficiency and reducing downtime.​",
        "meta_img": "Data-driven-Maintenance-Training.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "4",
        "certificate_ref_id": "5",
        "course_name": "Sustainability",
        "course_slug": "sustainability",
        "course_icon": "sustainability.svg",
        "course_snippet": "Participants will understand how Sustainability is connected with Industry 4.0 technologies in order to satisfy economic, environmental and social objectives.",
        "course_technology": "EHS, Energy Management Software.",
        "course_description": "Methods, systems, behaviours and Industry 4.0 technologies that help create products and solutions that address the needs of the present without compromising the ability of future generations to meet their needs.<br/><br/>Typical technologies in this area are Energy Management Software (EMS) and Environmental, Health & Safety (EHS) Software.",
        "skill_desc": "Methods, systems, behaviours and Industry 4.0 technologies that help create products and solutions that address the needs of the present without compromising the ability of future generations to meet their needs.\n<br><br>Typical technologies in this area are Energy Management Software (EMS) and Environmental, Health & Safety (EHS) Software.",
        "course_image": "Sustainability-Training-Course.png",
        "course_instructor": "2",
        "course_order": "5",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Understand how Sustainability is connected with Industry 4.0 technologies in order to satisfy economic, environmental and social objectives.​",
        "meta_img": "Sustainability-Training-Course.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "5",
        "certificate_ref_id": "6",
        "course_name": "Automated Material Flow",
        "course_slug": "automated-material-flow",
        "course_icon": "automated-material-flow.svg",
        "course_snippet": "Participants will learn how to transform the traditional material flows into highly automated ones and enable productivity, safety, accuracy and on time material delivery promoting the Factory of the Future.",
        "course_technology": "AGV, AMR, UAV / Drones, ASRS, WMS, YMS​.",
        "course_description": "Implementation of machinery & systems that automate & optimize material handling processes throughout the manufacturing facility.<br/><br/>This is critical to enable productivity, safety, accuracy and on time material delivery which is key in driving efficiencies and synchronizing manufacturing with the extended supply chain.",
        "skill_desc": "Implementation of machinery & systems that automate & optimize material handling processes throughout the manufacturing facility.\n<br><br>This is critical to enable productivity, safety, accuracy and on time material delivery which is key in driving efficiencies and synchronizing manufacturing with the extended supply chain.",
        "course_image": "Automated-Material-Flow-Training.png",
        "course_instructor": "1",
        "course_order": "6",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Learn how to transform the traditional material flows into highly automated ones and enable productivity, safety, accuracy and on time material delivery promoting the Factory of the Future.​",
        "meta_img": "Automated-Material-Flow-Training.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "6",
        "certificate_ref_id": "7",
        "course_name": "Digital-Ready Infrastructure",
        "course_slug": "digital-ready-infrastructure",
        "course_icon": "digital-ready-infrastructure.svg",
        "course_snippet": "​Participants will understand the systems that support the foundational framework to manage current and future data streams that will be available as a result of the Industry 4.0 journey.",
        "course_technology": "Cloud Computing, Edge Computing, Industrial Communication Systems, 5G, Cybersecurity, Network Intrusion Detection Systems​.",
        "course_description": "Systems that safeguard and enable the plant’s operations, ensure reliable and secure data streaming acting as a key enabler of Industry 4.0 transformation.<br/><br/>​They support the foundational framework to manage current and future data streams that will be available as a result of the Industry 4.0 journey.",
        "skill_desc": "Systems that safeguard and enable the plant’s operations, ensure reliable and secure data streaming acting as a key enabler of Industry 4.0 transformation.\n  <br><br>They support the foundational framework to manage current and future data streams that will be available as a result of the Industry 4.0 journey.",
        "course_image": "Digital-Ready-Infrastructure-Training.png",
        "course_instructor": "3",
        "course_order": "7",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "​Understand the systems that support the foundational framework to manage current and future data streams that will be available as a result of the Industry 4.0 journey.​",
        "meta_img": "Digital-Ready-Infrastructure-Training.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "7",
        "certificate_ref_id": "8",
        "course_name": "360° Factory Visibility",
        "course_slug": "360-factory-visibility",
        "course_icon": "360-factory-visibility.svg",
        "course_snippet": "Participants will learn more about the use of central repositories and effective integrations to ensure data availability and transparency that enable data-sharing with suppliers and customers.",
        "course_technology": "ERP, PLM, IIoT, Data Lake, Data Warehouse, Data Visualization, Blockchain, RPA​.",
        "course_description": "Systems that combine data from various areas of the value chain, eliminating silos & accelerating decision-making. They include software that covers several departments, such as ERP and Plant Manager Dashboards and integrations between these systems.<br/><br/>They offer a unified view of all operations and enable data-sharing with suppliers and customers, improving decision-making, reducing human errors, and driving process efficiencies.",
        "skill_desc": "Systems that combine data from various areas of the value chain, eliminating silos & accelerating decision-making. They include software that covers several departments, such as ERP and Plant Manager Dashboards and integrations between these systems.\n  <br><br>They offer a unified view of all operations and enable data-sharing with suppliers and customers, improving decision-making, reducing human errors, and driving process efficiencies.",
        "course_image": "360-Factory-Visibility-Training.png",
        "course_instructor": "3",
        "course_order": "8",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Learn more about the use of central repositories and effective integrations to ensure data availability and transparency that enable data-sharing with suppliers and customers.​",
        "meta_img": "360-Factory-Visibility-Training.png\n",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "8",
        "certificate_ref_id": "9",
        "course_name": "Intelligent Quality",
        "course_slug": "intelligent-quality",
        "course_icon": "intelligent-quality.svg",
        "course_snippet": "Participants will learn how to leverage real time data to manage quality control and assurance and enhance quality by simultaneously increase operational advantages.",
        "course_technology": "QMS, Foreign Object Detection Systems, LIMS, Machine Vision, Predictive Quality​.",
        "course_description": "Effective integration of sensors, software, and techniques that leverage real-time data to manage quality control and quality assurance.<br/><br/>All these technologies and techniques are delivering enhanced quality and operational advantages.",
        "skill_desc": "Effective integration of sensors, software, and techniques that leverage real-time data to manage quality control and quality assurance.<br><br>\n        All these technologies and techniques are delivering enhanced quality and operational advantages.",
        "course_image": "Intelligent-Quality-Training.png",
        "course_instructor": "5",
        "course_order": "9",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Learn how to leverage real time data to manage quality control and assurance and enhance quality by simultaneously increase operational advantages.​",
        "meta_img": "Intelligent-Quality-Training.png",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "9",
        "certificate_ref_id": "10",
        "course_name": "Tech-Augmented Workforce",
        "course_slug": "tech-augmented-workforce",
        "course_icon": "tech-augmented-workforce.svg",
        "course_snippet": "Participants will understand why an augmented worker is an essential part of the Industry 4.0 ecosystem. They will also get exposed to technologies that open new horizons in productivity, democratizing value creation.",
        "course_technology": "Machine Vision, AR, VR, Industrial Tablets / Smartphones, Industrial Wearables, Connected Workforce Platform​.",
        "course_description": "Technologies that assist employees in their tasks by augmenting their skillset and optimizing workflows.<br/><br/>These technologies provide access to information and expertise and are opening new horizons in productivity, efficiency and innovation, democratizing value creation.",
        "skill_desc": "Technologies that assist employees in their tasks by augmenting their skillset and optimizing workflows.<br><br>\n        These technologies provide access to information and expertise and are opening new horizons in productivity, efficiency and innovation, democratizing value creation.",
        "course_image": "Tech-Augmented-Workforce-Training.png",
        "course_instructor": "5",
        "course_order": "10",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Understand why an augmented worker is an essential part of the Industry 4.0 ecosystem. They will also get exposed to technologies that open new horizons in productivity, democratizing value creation.​",
        "meta_img": "Tech-Augmented-Workforce-Training.png\n",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    },
    {
        "id": "10",
        "certificate_ref_id": "11",
        "course_name": "Zero-Touches Production",
        "course_slug": "zero-touches-production",
        "course_icon": "zero-touches-production.svg",
        "course_snippet": "Participants will learn about combining hardware, software and practices to eliminate human effort in production. These technologies enable agility, flexibility and throughput improvements to daily production cycles.",
        "course_technology": "Cobots, End of arm tooling, Soft Robotics, Machine Vision, MES, Digital Twin.",
        "course_description": "Hardware, software, and practices, that eliminate human effort in production execution and streamline the production system towards lights-off operations.<br/><br/>These technologies and practices enable agility, flexibility and throughput improvements to daily production cycles.",
        "skill_desc": "Hardware, software, and practices, that eliminate human effort in production execution and streamline the production system towards lights-off operations.<br><br>\n        These technologies and practices enable agility, flexibility and throughput improvements to daily production cycles.",
        "course_image": "Zero-Touches-Production-Training.png",
        "course_instructor": "4",
        "course_order": "11",
        "social_url": "/industry-40-training-courses",
        "price": "100",
        "meta_desc": "Learn about combining hardware, software and practices to eliminate human effort in production. These technologies enable agility, flexibility and throughput improvements to daily production cycles.​",
        "meta_img": "Zero-Touches-Production-Training.png\n",
        "is_imd": "0",
        "is_active": "1",
        "cardStatus": "To Do",
        "cardClass": "to-do",
        "Score": "-"
    }
]
  
  const user = localStorage.getItem("group_id");
  const group_id = user ? user : 0;
  const quizDataItem = {};
  const inviteteam = quizDataItem.invitedMembers;
  //defining variables here
  const [assignedUsers, setAssignedUsers] = useState([]);


  const handleAssignPoup = (e) => {
  };
  // Add to cart function
  const { addProduct, cartItems, increase } = useContext(CartContext);
  const isInCart = (id) => {
    return !!cartItems.find((item) => item.id === id);
  };
  const addToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add('added-cart-btn');
  }

  useEffect(() => {
    setAssignedUsers(inviteteam);
  }, []);


  return (
    <>
      {/* this section has page title */}
      <Helmet>
        <title>Skills Assessment | SmarterChains</title>
        <meta name="description" content="Training Courses" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      {/* breadcrumbs */}
      <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
      <BreadcrumbsItem to="#">Skills Assessment</BreadcrumbsItem>
      <section className="skillsassessment">
        <div className="all-sellection-main">
          {/* heading */}
          <h1 className="course__overView__h1 skills">
            <span className="skills">Skills Assessment</span>
            <div className="assigned-user-div" data-title="Assign Users">
              <div className="scnv-2147-cir-user">
                
              </div>
              <button className="assign-cir-icon" onClick={(e) => { handleAssignPoup(e) }}>
                  <i className="icon-svg">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="white" stroke="#118ACB"></circle>
                      <path d="M11.2831 9.94842C12.7426 9.94842 13.9246 8.84121 13.9246 7.47421C13.9246 6.10721 12.7426 5 11.2831 5C9.82364 5 8.64155 6.10721 8.64155 7.47421C8.64155 8.84121 9.82364 9.94842 11.2831 9.94842ZM11.2831 11.1855C9.51986 11.1855 6 12.0144 6 13.6597V14.8968H16.5662V13.6597C16.5662 12.0144 13.0463 11.1855 11.2831 11.1855Z" fill="#118ACB"></path>
                      <ellipse cx="16.2263" cy="14.4026" rx="2.77363" ry="2.59792" fill="white"></ellipse>
                      <rect x="15.8301" y="12.5469" width="0.792465" height="3.71132" fill="#118ACB"></rect>
                      <rect x="18.2075" y="14.0303" width="0.742263" height="3.96232" transform="rotate(90 18.2075 14.0303)" fill="#118ACB"></rect>
                    </svg>
                  </i>
                </button>
            </div>
          </h1>

          {skillData?.map((items, i) => {
            return (
             
              <a data-index={0} href={`/skill-assessment/${items.course_slug}`} className={`all-sellection-card ${items.cardClass === `notavailable` ? 'disable-card' : 'active'}`} >
                <div className="left-img-box">
                  <img src={require(`../../assets/img/skillsassessment/Course-Icons${items.id}.svg`).default} alt={items.course_slug} />
                </div>
                <div className="text-box">
                  <div className="text-left">
                    <h2 className="h1">
                      <span>{items.course_name} Assessment</span>
                    </h2>
                    {/* Added classes for status change 'to-do' for To Do, 'inprogress' for In Progress, 'complete' for Completed */}
                    <div className="skill-bottom-status">
                      <p className={`skill-assessment-status ${items.cardClass}`}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="status" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="6" cy="6" r="6" fill="#DB324D" />
                        </svg>
                        <span className="res-text">{items.cardStatus}</span>
                      </p>
                      {(items.cardStatus === 'Completed' && items.Score < 70) &&
                        <>
                          <span className="recommend-text">Training recommended</span>
                          <Link to={`/training-courses/${items.course_slug}`} className="skill-view-btn">View Course</Link>

                          {/* Add class 'added-cart-btn' conditionally */}
                          {quizDataItem?.paid_training?.includes(String(items.id)) === false &&
                            <button className={`skill-cart-btn   ${isInCart(items.id) ? 'added-cart-btn' : 'added-cart-btn1'}`} onClick={(e) => { addProduct(items); addToCart(e); }}>
                              <span className="not-added-cart">Add to Cart</span>
                              <div className="added-cart">
                                <i dangerouslySetInnerHTML={{ __html: checkSvg }}></i>
                                <span>Added to Cart</span>
                              </div>
                            </button>
                          }

                        </>
                      }
                    </div>
                  </div>
                  <div className="text-cir">
                    <svg viewBox="0 0 36 36">
                      <text
                        className="percent__text"
                        x="50%"
                        y="38%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize={6}
                        fontWeight={400}
                      >
                        Score
                      </text>
                      <text
                        className="percent__text"
                        x="50%"
                        y="63%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fontSize={6}
                        fontWeight={700}
                      >
                        {`${items.Score}${items.Score == '-' ? '' : '%'}`}
                      </text>
                      <path
                        className="circle-bg"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831  a 15.9155 15.9155 0 0 1 0 -31.831"
                        stroke={
                          items.Score === 0 ? '#EBF5FA'
                            : items.Score < 70 && items.Score > 0 ? '#FAE2E5'
                              : items.Score >= 70 ? '#E5F5F1'
                                : '#EBF5FA'
                        }
                        strokeWidth="2.4"
                        fill="none"
                      />
                      <path
                        className="circle"
                        strokeDasharray={`${items.Score == '-' ? 0 : items.Score}, 100`}
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        stroke={
                          items.Score < 70 ? '#E25B71'
                            : items.Score >= 70 ? '#45B097' : ''
                        }
                        strokeWidth="2.4"
                        fill="none"
                      />
                    </svg>
                  </div>
                </div>
                {/* this section has navigation */}
                <div className="angle-box">
                  <img
                    src={
                      require(`../../assets/img/skillsassessment/right-angle.svg`)
                        .default
                    }
                    alt="true"
                  />
                </div>
                <div className="sellection-card-popup false ">
                  <h2>{items.course_name} Assessment</h2>
                  <div>

                    <p dangerouslySetInnerHTML={{ __html: items.skill_desc }}></p>

                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </section>
    </>
  );
};

const checkSvg = `<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2012_107087" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
<rect y="0.5" width="20" height="20" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_2012_107087)">
<path d="M8.83464 14.3346L14.7096 8.45964L13.543 7.29297L8.83464 12.0013L6.45964 9.6263L5.29297 10.793L8.83464 14.3346ZM10.0013 18.8346C8.84852 18.8346 7.76519 18.6159 6.7513 18.1784C5.73741 17.7409 4.85547 17.1471 4.10547 16.3971C3.35547 15.6471 2.76172 14.7652 2.32422 13.7513C1.88672 12.7374 1.66797 11.6541 1.66797 10.5013C1.66797 9.34852 1.88672 8.26519 2.32422 7.2513C2.76172 6.23741 3.35547 5.35547 4.10547 4.60547C4.85547 3.85547 5.73741 3.26172 6.7513 2.82422C7.76519 2.38672 8.84852 2.16797 10.0013 2.16797C11.1541 2.16797 12.2374 2.38672 13.2513 2.82422C14.2652 3.26172 15.1471 3.85547 15.8971 4.60547C16.6471 5.35547 17.2409 6.23741 17.6784 7.2513C18.1159 8.26519 18.3346 9.34852 18.3346 10.5013C18.3346 11.6541 18.1159 12.7374 17.6784 13.7513C17.2409 14.7652 16.6471 15.6471 15.8971 16.3971C15.1471 17.1471 14.2652 17.7409 13.2513 18.1784C12.2374 18.6159 11.1541 18.8346 10.0013 18.8346Z" fill="#43A047"/>
</g>
</svg>
`


